var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1963_37748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0684 0H1.63818V25H23.3613V5.29298L18.0684 0ZM18.3614 1.70701L21.6543 4.99997H18.3614V1.70701ZM22.3613 24H2.63822V0.999984H17.3614V6H22.3614L22.3613 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0234 16.8535V22.4368H20.711V16.8535H16.0234ZM19.711 21.4367H17.0235V17.8535H19.711V21.4367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1558 13.8535V22.4368H14.8433V13.8535H10.1558ZM13.8433 21.4367H11.1558V14.8535H13.8433V21.4367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28809 10.8535V22.4368H8.9756V10.8535H4.28809ZM7.97556 21.4367H5.28807V11.8535H7.97556V21.4367Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1963_37748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMenu);
export default __webpack_public_path__ + "static/media/report-menu.a16bedfb1c86ddbab56a04386f794d6b.svg";
export { ForwardRef as ReactComponent };